import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Face4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"face_4"}/>
}
